import { IEnrollment } from 'src/app/core/models/enrollments.model';

export enum AppointmentOptionsToShow {
  Sub = 'sub',
  Both = 'both',
  Direct = 'direct',
}

export enum Locations {
  Appointments = 'Appointments',
  QuotePresentation = 'Quote Presentation Knockout',
  FirstTimeWizard = 'First Time Wizard',
}

export enum AppointmentAction {
  Connect = 'Connect',
  Disconnect = 'Disconnect',
  Edit = 'Update',
  View = 'View',
  Pending = 'Pending',
}

export enum Status {
  Active = 'active',
  Pending = 'pending',
  Inactive = 'inactive',
}

export interface IAppointmentDialogData {
  type: AppointmentAction;
  isDirect: boolean;
  enrollment: IEnrollment;
  isFTW: boolean;
  incompleteQuestionGroups?: string[];
  removeQueuedEnrollment?: boolean;
}

export interface IDialogConfig {
  title: string;
  actionButton: string;
  status: Status;
  successMessage?: string;
}

type ConfigKeys =
  | 'connectDirect'
  | 'connectSub'
  | 'carrierQuestionSet'
  | 'disconnect'
  | 'editDirect'
  | 'pending'
  | 'view';

export const dialogConfigs: Record<ConfigKeys, IDialogConfig> = {
  connectDirect: {
    title: 'Connect to carrier',
    actionButton: 'Connect',
    status: Status.Inactive,
    successMessage: 'direct appointment has been connected.',
  },
  connectSub: {
    title: 'Connect to carrier',
    actionButton: 'Request',
    status: Status.Inactive,
    successMessage:
      'sub-appointment has been requested. You will receive a status update via email.',
  },
  carrierQuestionSet: {
    title: 'Complete carrier compliance questions',
    actionButton: 'Continue',
    status: Status.Inactive,
    successMessage:
      'sub-appointment has been requested. You will receive a status update via email.',
  },
  editDirect: {
    title: 'Edit your carrier connection',
    actionButton: 'Update',
    status: Status.Active,
    successMessage: 'appointment has been successfully updated.',
  },
  disconnect: {
    title: 'Disconnect your carrier connection',
    actionButton: 'Disconnect',
    status: Status.Active,
    successMessage:
      'appointment has been disconnected and is now marked as inactive.',
  },
  view: {
    title: 'Your carrier connection',
    actionButton: 'Close',
    status: Status.Active,
  },
  pending: {
    title: 'Your carrier connection',
    actionButton: 'Close',
    status: Status.Pending,
  },
};

export const resourceGuideKeys = {
  atbay: '8736599-at-bay',
  attuneoffplatform: '6414853-attune',
  berkleycarrier: '8753898-berkley',
  biberk: '6414897-biberk',
  cna: '6414915-cna',
  coterie: '6417892-coterie',
  cowbellcarrier: '6310082-cowbell',
  hiscox: '6310179-hiscox',
  markel: '6418326-markel',
  nextcarrier: '8485899-next',
  pathpoint: '8461508-pathpoint',
  rtspecialty: '9615546-rt-specialty',
  threeoffplatform: '8346160-three',
  travelers: '9882097-travelers',
  westfieldcarrier: '6418370-westfield',
  uticafirst: '9484383-utica-first',
};
